// extracted by mini-css-extract-plugin
export default {"honorific":"Radiobox_honorific__8SvYm"};